import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IRouteReducerSliceStateInit } from "../slice_interface";
import { IAppointmentCartItemsMappingListResponseData } from "@/api_framework/api_modals/Mapping";

export interface IMappingsState {
  appointmentCartItemsMappingList: IAppointmentCartItemsMappingListResponseData[];
  appointmentCartItemMappingDetail: IAppointmentCartItemsMappingListResponseData;
  appointmentCartItemMappingUpdate: IAppointmentCartItemsMappingListResponseData;
}
export interface IMappingsInitialState extends IRouteReducerSliceStateInit {
  state: IMappingsState;
}

const initialState: IMappingsInitialState = {
  state: {
    appointmentCartItemsMappingList: null,
    appointmentCartItemMappingDetail: null,
    appointmentCartItemMappingUpdate: null,
  },
};

const mappingsSlice = createSlice({
  name: "mappings_slice",
  initialState: initialState,
  reducers: {
    // RESET_INVENTORY: () => {
    //   return initialState;
    // },
    setAppointmentCartItemsMappingList: (
      state,
      action: PayloadAction<{
        data: IAppointmentCartItemsMappingListResponseData[];
      }>,
    ) => {
      state.state.appointmentCartItemsMappingList = action.payload.data;
    },
    setAppointmentCartItemMappingDetail: (
      state,
      action: PayloadAction<{
        data: IAppointmentCartItemsMappingListResponseData;
      }>,
    ) => {
      state.state.appointmentCartItemMappingDetail = action.payload.data;
    },
    setAppointmentCartItemMappingUpdate: (
      state,
      action: PayloadAction<{
        data: IAppointmentCartItemsMappingListResponseData;
      }>,
    ) => {
      state.state.appointmentCartItemMappingUpdate = action.payload.data;
    },
  },
});

export const {
  setAppointmentCartItemsMappingList,
  setAppointmentCartItemMappingDetail,
  setAppointmentCartItemMappingUpdate,
} = mappingsSlice.actions;
export default mappingsSlice.reducer;
